import * as React from 'react'

import { Icon, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

interface InformationTooltipProps {
  label: string
}

export const InformationTooltip = ({ label }: InformationTooltipProps) => {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip.Alt open={open} toggle={toggle} attachment="bottom center" label={label}>
      <Icon.Small icon="question" encircled="grey800" />
    </Tooltip.Alt>
  )
}
